import React from "react";

/**
 *
 */
export type NutrientData = {
    id : string
    name : string
    translation : string
    trafficLight : string
    description : string
    source : string
    proportion : number
    type : string
    children : NutrientData[]
};

/**
 *
 */
type Data = {
    nutrient : NutrientData
};

/**
 *
 * @param nutrient
 * @constructor
 */
export default function Nutrient ({ nutrient } : Data) {
    // init
    const itemId = 'nutrient-id-' + nutrient.id;
    const collapsedId = 'nutrient-collapsed-id-' + nutrient.id;

    // render
    return (
        <div className="accordion-item bg-light">
            <h3 className="accordion-header" id={itemId}>
                <button className="accordion-button collapsed bg-light p-1 ps-0 pe-0 pt-3 pb-3 border-0 shadow-none" type="button" data-bs-toggle="collapse"
                        data-bs-target={'#' + collapsedId} aria-expanded="false" aria-controls={collapsedId}>
                    <div className={'row w-100'}>
                        <div className={'col-7 col-md-5'}>{nutrient.translation}</div>
                        <div className={'col-4 col-md-3 text-end' + ('yellow' === nutrient.trafficLight ?
                            " text-warning fw-bold" :
                            ('red' === nutrient.trafficLight ? " text-danger fw-bold" : ('green' === nutrient.trafficLight ? " text-success fw-bold" : "")))}>{nutrient.proportion } %
                        </div>
                    </div>
                </button>
            </h3>
            <div id={collapsedId} className="accordion-collapse collapse" aria-labelledby={itemId}
                 data-bs-parent="#nutrientList">
                <div className="accordion-body p-1 mb-1">
                    {nutrient.children.length ? <ul>
                        {nutrient.children.map((nutrientChild) =>
                            <li key={nutrientChild.id}>
                                <span>{nutrientChild.translation}</span>
                                <span className={'ps-3' + ('yellow' === nutrientChild.trafficLight ?
                                    " text-warning fw-bold" :
                                    ('red' === nutrientChild.trafficLight ? " text-danger fw-bold" : ('green' === nutrientChild.trafficLight ? " text-success fw-bold" : "")))}>{nutrientChild.proportion } %</span>
                            </li>
                        )}
                    </ul> : ''}
                    <p>
                        {nutrient.description}<br />
                        <small className={'fst-italic'}>{nutrient.source}</small>
                    </p>
                </div>
            </div>
        </div>
    );
}